// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__d4Nu7","dragIcon":"SortableItem_dragIcon__DFPsl","disabled":"SortableItem_disabled__sVFbW"};